import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';

const EmailBodyTemplateField: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	return <FullInfoField label="emailBodyTemplateLabel" value={customerForFullInfo?.emailBodyTemplate} />;
};

export default EmailBodyTemplateField;
